import useResources from "../../../hooks/UseResources";
import * as AllergyTypeService from "../../../services/AllergyTypeService";

export default function useAllergyTypes() {
    return useResources(AllergyTypeService.getAllAllergyTypes, "data");
}
